/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa inputów formularzy
 * input-invalid / input-valid
 *
 * @export
 * @class Inputs
 */

export class Inputs {
	constructor() {
	}
	// ****************************************************************************************************
	// Inicjalizacja iputu type=email
	// ****************************************************************************************************
	initEmailInput(input) {
		var that = this;
		var pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		var required = input.hasClass('required');
		var checkPattern = input.hasClass('email1'); // email1 | required
		var checkIsIdenticalEmail = input.hasClass('email2');
		input.off().on('keyup', function () {
			input.val(toolsObj.removeWhitespace(input.val())); // blokuje uzycie spacji
			that.clearInputClass(input);
		}).on('blur', function () {
			if (required)
				input.trigger('validateInput');
		}).on('change', function () {
			if (required)
				input.trigger('validateInput');
		}).on('validateInput', function (event) {
			that.clearInputClass(input); if ((!input.val() || input.val() == '') && required) { // input wymagany jest pusty
				input.addClass('input-required');
			}
			else if (checkPattern && !pattern.test(input.val().toLowerCase())) { // input niepoprawna wwartosc
				input.addClass('input-invalid');
			}
			else if (checkIsIdenticalEmail && input.val() != $('input.email1').val()) { // input niepoprawna wwartosc
				input.addClass('input-invalid');
			}
			else if (checkPattern || checkIsIdenticalEmail) {
				input.addClass('input-valid');
			}
			else {
			}
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja iputu type=password
	// ****************************************************************************************************
	initPasswordInput(input) {
		var that = this;
		if (input.hasClass('likeTextInput')) {
			that.initTextInput(input);
			return false;
		}
		var passwordStrengthPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#+-_.,=:;|~`()^])[A-Za-z\d@$!%*?&#+-_.,=:;|~`()^]{8,64}$/i; // min 8 max 64 znaki, 1 litera, 1 cyfra, 1 znak specjalny, BEZ  SPACJI ToDo - dostosować listę znaków specjalnych
		var required = input.hasClass('required');
		var checkPasswordStrength = input.hasClass('password1'); // password1 | required
		var checkIsIdenticalPassword = input.hasClass('password2');
		input.off().on('keyup', function () {
			//input.val(toolsObj.removeWhitespace(input.val()));
			that.clearInputClass(input);
		}).on('blur', function () {
			if (required)
				input.trigger('validateInput');
		}).on('change', function () {
			if (required)
				input.trigger('validateInput');
		}).on('validateInput', function (event) {
			that.clearInputClass(input);
			if ((!input.val() || input.val() == '') && required) { // input wymagany jest pusty
				input.addClass('input-required');
			}
			else if (checkPasswordStrength && !passwordStrengthPattern.test(String(input.val()))) { // input słabe haslo .toLowerCase()
				input.addClass('input-invalid');
			}
			else if (checkIsIdenticalPassword && input.val() != $('input.password1').val()) { // powtórzone hasło niezgodne z pierwszym
				input.addClass('input-invalid');
			}
			else if (checkPasswordStrength || checkIsIdenticalPassword) {
				input.addClass('input-valid');
			}
			else {
			}
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja iputu type=search
	// ****************************************************************************************************
	initSearchInput(input) {
		var that = this;
		that.asignInputValidationEvents(input);
	}
	// ****************************************************************************************************
	// Inicjalizacja iputu type=text !!!! TYLKO !!!! z klasa required
	// ****************************************************************************************************
	initTextInput(input) {
		var that = this;
		if ( input.attr('name').includes('nipSufix') && input.hasClass('required') ) {
			that.initVatIdValidation(input);
		} else {
			if (input.hasClass('required')) {
				input.off().on('keyup', function () {
					that.clearInputClass(input);
				}).on('blur', function () {
					input.trigger('validateInput');
				}).on('change', function () {
					input.trigger('validateInput');
				}).on('validateInput', function (event) {
					that.clearInputClass(input);
					input.val(toolsObj.removeWhitespace(input.val())); // usunięcie spacji z początku lub konca stringa
					if (!input.val() || input.val() == '') { // input wymagany jest pusty
						input.addClass('input-required');
					} else if ( input.hasClass('required') && ( input.attr('name').includes('kodpocztowy') || input.attr('name').includes('kod_pocztowy') || input.attr('name').includes('KodPocztowy') ) ) { // obsługa validacji kodu pocztowego PL
						that.validateZipCode(input);
					} else {
						input.addClass('input-valid');
					}
				});
			}
		}
	}
	// ****************************************************************************************************
	// Validacja kodu pocztowego
	// ****************************************************************************************************
	validateZipCode(input){
		let patternZipCodePL = /^[0-9]{2}-[0-9]{3}$/g;
		let country = null;
		let selectInput = $("select[name=kraj], select[name=kraj_d], select[name=dak_kraj]");

		if ( selectInput.length > 0 ) {
			selectInput = selectInput.first();
			country = selectInput.val();
		}

		if ( ANONIM || country == "PL" ) { // ANONIM = true sprzedaż tylko w PL
			if ( patternZipCodePL.test(String(input.val())) ) {
				input.addClass('input-valid');
			} else {
				input.addClass('input-invalid');
			}
		} else {
			input.addClass('input-valid');
		}
	}
	// ****************************************************************************************************
	// Inicjalizacja walidacji NIP
	// !Wymagane: input id="vatId" type="hidden", select id="vatIdCountry",input id="vatIdPrefix"
	// ****************************************************************************************************
	initVatIdValidation(input) {
		var that = this;
		that.vatIdInput = $('#vatId');
		that.vatIdCountry = $('#vatIdCountry');
		that.vatIdPrefix = $('#vatIdPrefix');
		that.vatIdSufix = input;
		if (that.vatIdCountry.length == 0 || that.vatIdPrefix.length == 0 || that.vatIdInput.length == 0) {
			console.error('ERORR - init - tax identification number');
			return false;
		}
		$.ajax({
			dataType: "json",
			url: "/pages/JSON/vat_id_validation_data.json",
			mimeType: "application/json",
			success: function (json) {
				that.vatIdValidationData = json;
				that.updateCaptionInfo();
				that.initVatIdCountrySelect();
				that.initVatIdInput();
			},
			error: function () {
				console.error('VAT ID validation - data file missing');
			}
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja selectu z wyborem kraju
	// ****************************************************************************************************
	initVatIdCountrySelect() {
		var that = this;
		that.vatIdCountry.off().on('change', function () {
			if (that.vatIdCountry.val() == '') {
				that.vatIdPrefix.val('');
				that.vatIdSufix
					.data('save', that.vatIdSufix.val())
					.val('')
					.attr('disabled', true);
			} else {
				if ($('#countryOption-' + that.vatIdCountry.val()).data('is_ue') == 'N')
					that.vatIdPrefix.val('');
				else
					that.vatIdPrefix.val(that.vatIdCountry.val());
				that.vatIdSufix.removeAttr('disabled').val(function () {
					if (that.vatIdSufix.val() == '')
						return (that.vatIdSufix.data('save')) ? that.vatIdSufix.data('save') : that.vatIdSufix.val();
					else
						return that.vatIdSufix.val();
				});
			}
			that.updateCaptionInfo();
			that.updateVatIdValue();
			that.vatIdSufix.trigger('validateInput');
			that.vatIdCountry.trigger('validateInput');
		}).on('click', function () {
			that.vatIdCountry.trigger('validateInput');
		}).on('blur', function () {
			that.vatIdCountry.trigger('validateInput');
		}).on('validateInput', function (event) {
			that.clearInputClass(that.vatIdCountry);
			if (that.vatIdCountry.prop('selectedIndex') == 0) {
				if ( !that.vatIdCountry.hasClass('skipValidation') )
					that.vatIdCountry.addClass('required').addClass('input-required');
				that.clearInputClass(that.vatIdSufix);
			}
			else
				that.vatIdCountry.removeClass('required');
		});
	}
	// ****************************************************************************************************
	// Aktualizacja legendy dla NIP
	// ****************************************************************************************************
	updateCaptionInfo() {
		var that = this;
		var captionInfo = $('#captionInfo');
		var captionMask = $('#mask');
		var caption = $('#caption');
		var orHtml = '<span class="maskOr">' + captionMask.data('or') + '</span>';
		var fromHtml = '<span class="maskFrom">' + captionMask.data('from') + '</span>';
		var toHtml = '<span class="maskTo">' + captionMask.data('to') + '</span>';
		var prefix = that.vatIdCountry.val();
		if (that.vatIdValidationData[prefix] !== undefined) {
			$('.captionPos').hide();
			that.vatIdValidationData[prefix].captionLabels.forEach(function (e) {
				$('.' + e).show();
			});
			captionInfo.show();
			if (that.vatIdValidationData[prefix].captionLabels.length > 1) {
				caption.show();
			}
			else
				caption.hide();
			captionMask.html(that.vatIdValidationData[prefix].mask.join('').replace(/__html_or__/g, orHtml).replace('__html_from__', fromHtml).replace('__html_to__', toHtml));
		}
		else {
			captionInfo.hide();
			if (prefix != '' && $('#countryOption-' + prefix).data('is_ue') == 'T')
				console.error('ERROR no data for vat id verification - no caption info for:', prefix);
		}
	}
	// ****************************************************************************************************
	// Inicjalizacja pola NIP SUFIX
	// ****************************************************************************************************
	initVatIdInput() {
		var that = this;
		that.vatIdSufix.off().on('keyup', function () {
			that.clearInputClass(that.vatIdSufix);
			that.vatIdSufix.val(that.vatIdSufix.val().toUpperCase());
			if ($('#countryOption-' + that.vatIdCountry.val()).data('is_ue') == 'T') {
				that.removeDisallowSignsFromSufix();
			}
		}).on('blur', function () {
			that.vatIdSufix.trigger('validateInput');
		}).on('change', function () {
			that.vatIdSufix.trigger('validateInput');
		}).on('validateInput', function (event) {
			that.clearInputClass(that.vatIdSufix);
			$('.alertVies').hide();
			var regex = new RegExp('[ ]+$', 'gm'); // trolling spaces
			that.vatIdSufix.val(that.vatIdSufix.val().replace(regex, ''));
			if (!that.vatIdSufix.val() || that.vatIdSufix.val() == '') { // input wymagany jest pusty
				that.vatIdSufix.addClass('input-required');
			}
			else if (!that.validateVatIdInput()) { // input niepoprawna wwartosc
				that.vatIdInput.val('');
				that.vatIdSufix.addClass('input-invalid');
			}
			else if (!that.validateVatIdInVies()) { // weryfikacja NIP w
				that.vatIdInput.val('');
				that.vatIdSufix.addClass('input-failed');
			}
			else {
				that.updateVatIdValue();
				that.vatIdSufix.addClass('input-valid');
			}
		});
	}
	// ****************************************************************************************************
	// Czyszczenie sufixu z niedozwolonych znaków
	// ****************************************************************************************************
	validateVatIdInVies() {
		var that = this;
		var sufix = that.vatIdSufix.val();
		var prefix = that.vatIdPrefix.val();
		var $res = true;
		if ( that.vatIdValidationData[prefix] === undefined )
			return true;
		if ( prefix == '' || $('#countryOption-' + prefix).data('is_ue') == 'N' || !that.vatIdValidationData[prefix].validateInVies )
			return true;
		$('.alertVies').hide();
		$('#viesInProgress').show();
		$.ajax({
			method: 'GET',
			dataType: "html",
			url: "/info/common/vies.php?c_id=" + prefix + "&vat_id=" + sufix,
			async: false,
			success: function (data) {
				$('.alertVies').hide();
				if (data.includes('invalid')) {
					$('#viesWrong').show();
					$res = false;
				}
				else if (data.includes('valid')) {
					$('#viesOK').show();
				}
				else {
					$('#viesPassing').show();
				}
			},
			error: function () {
				$('.alertVies').hide();
				$('#viesPassing').show();
				console.error('ERROR VIES validation FAILED - prefix:', prefix);
			}
		});
		return $res;
	}
	// ****************************************************************************************************
	// Czyszczenie sufixu z niedozwolonych znaków
	// ****************************************************************************************************
	removeDisallowSignsFromSufix() {
		var that = this;
		var sufix = that.vatIdSufix.val();
		var prefix = that.vatIdPrefix.val();
		var regexDS;
		var regexMS = new RegExp('[ ]{2,}', 'gm');
		if (that.vatIdValidationData[prefix].disallowSigns !== undefined) {
			regexDS = new RegExp(that.vatIdValidationData[prefix].disallowSigns, 'g');
			that.vatIdSufix.val(sufix.replace(prefix, '').replace(regexDS, '').replace(regexMS, ' '));
		}
		else {
			console.error('ERROR no data for vat id verification - no disallow signs for:', prefix);
		}
	}
	// ****************************************************************************************************
	// Update pola #vatId
	// ****************************************************************************************************
	updateVatIdValue() {
		var that = this;
		var prefix = ($('#countryOption-' + that.vatIdCountry.val()).data('is_ue') == 'N') ? '' : that.vatIdCountry.val();
		var sufix = that.vatIdSufix.val();
		if (that.validateVatIdInput()) {
			if (prefix == 'PL') // na prosbe ksiegowosci
				that.vatIdInput.val(sufix);
			else
				that.vatIdInput.val(prefix + sufix);
		}
	}
	// ****************************************************************************************************
	// Walidacja poprawności Nip
	// ****************************************************************************************************
	validateVatIdInput() {
		var that = this;
		var prefix = that.vatIdCountry.val();
		var sufix = that.vatIdSufix.val();
		var regex;
		if (that.vatIdValidationData[prefix] === undefined && $('#countryOption-' + prefix).data('is_ue') == 'T' && prefix != '') {
			console.error('ERROR no data for vat id verification - no pattern for:', prefix);
			return true;
		}
		if ($('#countryOption-' + prefix).data('is_ue') == 'T' && prefix != '') {
			regex = new RegExp(that.vatIdValidationData[prefix].pattern, 'gm');
			return sufix.match(regex);
		}
		return true;
	}
	// ****************************************************************************************************
	// Inicjalizacja iputu type=checkbox
	// ****************************************************************************************************
	initCheckboxInput(input) {
		var that = this;
		if (input.hasClass('required')) {
			input.off().on('click', function () {
				input.trigger('validateInput');
			}).on('focus', function () {
				that.clearInputClass(input);
			}).on('blur', function () {
				input.trigger('validateInput');
			}).on('validateInput', function (event) {
				that.clearInputClass(input);
				if (!input.prop('checked')) {
					input.addClass('input-required');
				}
			});
		}
	}
	// ****************************************************************************************************
	// Inicjalizacja iputu type=file
	// Opcje:
	// atLeastOne - wystarczy, że dodoany jest 1 plik (a inputow jest więcej niż 1) (TYLKO pierwszy input dostaje errory)
	// sizeLimit - wyzwala sprawdzanie rozmiaru pliku (w inpucie wymagane: data-size-limit)
	// ****************************************************************************************************
	initFileInput(input) {
		var that = this;
		input.off().on('click', function () {
			//input.trigger('validateInput');
		}).on('focus', function () {
			that.clearInputClass(input);
		}).on('blur', function () {
			input.trigger('validateInput');
		}).on('change', function () {
			var f = this.files[0];
			if (input.hasClass('sizeLimit')) {
				var mbLimit = input.data('size-limit') / 1024 / 1024;
				var fileSize = f.size || f.fileSize;
				if (fileSize > input.data('size-limit')) {
					alert(TXT_FILE_SIZE_LIMIT_EXCEEDED.replace('xXx', mbLimit));
					input.val('');
				}
			}
			if (input.val() == '')
				input.next('label').html(TXT_DEFAULT_FILE_INPUT_LABEL);
			else
				input.next('label').html(f.name);
			input.trigger('validateInput');
		}).on('validateInput', function (event) {
			that.clearInputClass(input);
			if (input.hasClass('atLeastOne')) {
				var res = false;
				that.clearInputClass($('.atLeastOne').first());
				$('.atLeastOne').each(function (i, e) {
					if ($(e).val() != '') {
						res = true;
					}
				});
				if (!res)
					$('.atLeastOne').first().addClass('input-required');
			}
			else {
				if (input.val() == '') {
					input.addClass('input-required');
				}
			}
		});
	}
	// ****************************************************************************************************
	// Inicjalizacja select
	// ****************************************************************************************************
	initSelect(input) {
		var that = this;
		if (input.hasClass('required')) {
			input.off().on('click', function () {
				input.trigger('validateInput');
			}).on('change', function () {
				input.trigger('validateInput');
			}).on('focus', function () {
				that.clearInputClass(input);
			}).on('blur', function () {
				input.trigger('validateInput');
			}).on('validateInput', function (event) {
				that.clearInputClass(input);
				if (input.prop('selectedIndex') == 0) {
					input.addClass('input-required');
				}
				else {
					input.addClass('input-valid');
				}
			});
		}
	}
	// ****************************************************************************************************
	// Inicjalizacja Textarea
	// ****************************************************************************************************
	initTextarea(input) {
		var that = this;
		if (input.hasClass('required')) {
			input.off().on('change', function () {
				input.trigger('validateInput');
			}).on('focus', function () {
				that.clearInputClass(input);
			}).on('blur', function () {
				input.trigger('validateInput');
			}).on('validateInput', function (event) {
				that.clearInputClass(input);
				if (/^\s*$/g.test(input.val())) {
					input.addClass('input-required');
				}
				else {
					input.addClass('input-valid');
				}
			});
		}
	}
	// ****************************************************************************************************
	// Przypisanie eventu
	// ****************************************************************************************************
	asignInputValidationEvents(input) {
		var that = this;
		if (input.hasClass('required')) {
			input.off().on('inputValidationFailed', {
				dataSet: null
			}, function (event, form) {
				//console.log('inputValidationFailed');
				//form.addClass('input-invalid');
			}).on('inputValidationSuccess', {
				dataSet: null
			}, function (event, form) {
				//console.log('inputValidationSuccess');
				//input.addClass('input-valid');
			});
		}
	}
	// ****************************************************************************************************
	// Wyczyszczenie class dotyczących walidacji z inputu
	// ****************************************************************************************************
	clearInputClass(input) {
		input.removeClass('input-invalid').removeClass('input-valid').removeClass('input-required').removeClass('input-failed');
	}
	// ****************************************************************************************************
	// Inicjalizacja iputu ilości
	// ****************************************************************************************************
	initQuantityInput(input) {
		var that = this;
		if (input.data('lastValue') === undefined) {
			if (input.val() != '')
				input.data('lastValue', input.val());
		}
		input.off().on('change', function () {
			input.val(toolsObj.removeWhitespace(input.val()));
			//if ( !toolsObj.isPositiveFloat(input.val()) ) input.val(0); // removeLetters usuwa "-"
			input.val(toolsObj.removeLetters(input.val()));
			input.val(toolsObj.convertFloatSeparator(input.val()));
			input.val(toolsObj.removeMultipleSigns(input.val(), '.', '.'));
			input.val(toolsObj.removeLastZerosFromFloat(input.val()));


			if ( input.val() == '0' ) {
				input.val("");
			}

			if ( input.val() != '' ) {
				if ( that.validateQuantityInput(input) ) {
					input.data('lastValue', input.val());
				} else {
					input.val(input.data('lastValue'));
				}
			}
		});
	}
	// ****************************************************************************************************
	// Prosta walidacja inputu iloscc
	// ****************************************************************************************************
	validateQuantityInput(input) {
		//console.log('walidacja INPUT',input.data('isValidationBlocked'));
		var that = this;
		var precision = input.data('precision');
		if (!input.data('isValidationBlocked')) {
			if (input.val() == '' && !input.hasClass('correctEmpty')) {
				//console.log('walidacja INPUT PUSTY',input.val());
				input.val(input.data('lastValue'));
				//return false;
			} else if (input.val() == '' && input.hasClass('correctEmpty')) {
				return true;
			}
			if (input.val() == 0 && !input.hasClass('correctZero')) {
				//console.log('walidacja INPUT',input.val());
				input.val(input.data('lastValue'));
				//return true;
			}
			if (that.isCorrectPrecision(input.val(), precision)) {
				return true;
			} else {
				toolsObj.showModalAlert('<p class="mb-1">' + TXT_WRONG_QUANTITY + ':</p> <p class="h5 mb-0">' + precision + '</p>');
				input.focus();
				input.select();
				return false;
			}
		} else {
			input.data('isValidationBlocked', false);
			return true;
		}
	}
	// ****************************************************************************************************
	// Spr., czy ilość jest zgodna z precyzją (minimalną wielokrotnością zamawianej ilości)
	// ****************************************************************************************************
	isCorrectPrecision(value, precision) {
		var that = this;
		if (toolsObj.isPositiveFloat(value)) {
			var factor = 10000;
			return (toolsObj.roundTo(factor * value, 0) % toolsObj.roundTo(factor * precision, 0)) == 0;
		}
		else {
			return false;
		}
	}
}